import type {DataMessagePartComponent} from '@assistant-ui/react';
import React from 'react';

import type {WandbConversationPart} from '../../../agentChat/store/thread';
import {MentionPill} from './MentionPill';

/** ConversationMentionPart renders a conversation mention as an inline pill. */
export const ConversationMentionPart: DataMessagePartComponent<
  WandbConversationPart
> = ({data}) => (
  <MentionPill icon="forum-chat-bubble" text={data.conversationId} />
);
